import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {AppMainComponent} from './app.main.component';
import {AppNotfoundComponent} from './pages/app.notfound.component';
import {AppErrorComponent} from './pages/app.error.component';
import {AppAccessdeniedComponent} from './pages/app.accessdenied.component';
import {AppLoginComponent} from './pages/login/app.login.component';
import { AppLogoutComponent } from './pages/logout/app.logout.component';
import { Dashboard1Component } from './pages/home/dashboard1/dashboard1.component';
import { GraficosComponent } from './pages/home/graficos/graficos.component';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {path: 'auth/login', component: AppLoginComponent},
            {path: 'auth/logout', component: AppLogoutComponent},
            {
                path: 'pages', component: AppMainComponent,
                children: [
                    {path: 'home/inicio', component: Dashboard1Component},
                    {path: 'home/grafico', component: GraficosComponent},
                    {path: 'seguridad', loadChildren: () => import('./pages/seguridad/seguridad.module').then(m => m.SeguridadModule)},
                    {path: 'configuracion', loadChildren: () => import('./pages/configuracion/configuracion.module').then(m => m.ConfiguracionModule)},
                    // {path: 'contabilidad', loadChildren: () => import('./pages/contabilidad/contabilidad.module').then(m => m.ContabilidadModule)},
                    {path: 'tesoreria', loadChildren: () => import('./pages/tesoreria/tesoreria.module').then(m => m.TesoreriaModule)},
                    // {path: 'pagofacil', loadChildren: () => import('./pages/pagofacil/pagofacil.module').then(m => m.PagofacilModule)},
                    {path: 'cliente_tarjeta', loadChildren: () => import('./pages/cliente-tarjeta/cliente-tarjeta.module').then(m => m.ClienteTarjetaModule)},
                    {path: 'prestamo', loadChildren: () => import('./pages/prestamo/prestamo.module').then(m => m.PrestamoModule)},
                    {path: 'prestamo_solidario', loadChildren: () => import('./pages/prestamo-solidario/prestamo-solidario.module').then(m => m.PrestamoSolidarioModule)},
                    {path: 'notificacion', loadChildren: () => import('./pages/notificacion/notificacion.module').then(m => m.NotificacionModule)},
                    {path: 'crm', loadChildren: () => import('./pages/crm/crm.module').then(m => m.CrmModule)},
                    {path: 'seguimiento', loadChildren: () => import('./pages/seguimiento/seguimiento.module').then(m => m.SeguimientoModule)},
                    {path: 'asociaciones', loadChildren: () => import('./pages/asociaciones/asociaciones.module').then(m => m.AsociacionesModule )},
                ]
            },
            // {path: 'pages/landing', component: AppLandingComponent},
            {path: 'error', component: AppErrorComponent},
            {path: 'access', component: AppAccessdeniedComponent},
            {path: 'notfound', component: AppNotfoundComponent},
            // {path: 'wizard', component: AppWizardComponent},
            // {path: 'contactus', component: AppContactusComponent},
            {path: '', redirectTo: 'auth/login', pathMatch: 'full'},
            {path: '**', redirectTo: '/notfound'},
        ], {scrollPositionRestoration: 'enabled'})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
